<template>
    <div class="add_box pop-up2">
        <!-- <el-form :rules="rules" ref="formName" :model="form" label-width="150px" size="mini">
            
            <el-row class="form_row2">
                <el-col :span="22" class="">
                    <el-form-item label="复本数：" class="form_inp" prop="num">
                        
                    </el-form-item>
                </el-col>
            </el-row>
           
        </el-form> -->
        <el-input-number v-model="amount" :min="1" :max="5"></el-input-number>
        <div class="btn_box" style="padding-top:30px;">
            <el-button class="btn_add_canle" size="mini" @click="cancelInventtory">取消</el-button>
            <el-button class="btn_add_sure" size="mini" type="primary" @click="submitSave" :disabled="isLoad">保存
            </el-button>
        </div>
    </div>
</template>

<script>
    import { Button, InputNumber } from 'element-ui'
    // import { addMoreOrder} from '@/api/common'
    import { addMoreOrder, addMoreOrderBookTemp } from '@/api/pages'
    import Cookies from 'js-cookie'
    import addCarBefore from "./addCarBefore";
    import Axios from "@/api/diyaxios";
    import popup from "../common/plugin/dialog/index.js";
    import { insertPoint } from '@/api/insertPoints'   //添加埋点

    export default {
        props: ['objdata', 'intype'],
        components: {
            'el-button': Button, 'el-input-number': InputNumber,
        },
        data() {

            // let checkNum = (rule,value,callback) =>{
            //     let regExp = /^[1-9][0-9]*$/;
            //     if(new RegExp(regExp).test(value)){
            //         callback();
            //     }else{
            //         callback(new Error('复本数必须为大于0的正整数！'));
            //     }
            // };

            return {
                amount: 1,
                isLoad: false,
                source: Cookies.get("source"),
                adminState: Cookies.get("adminState"),

            }
        },
        watch: {

        },
        created() {

        },
        mounted() {

            let vm = this;

        },
        methods: {
            beforeAddCar(obj) {
                return new Promise((resolve, reject) => {
                    let vm = this;
                    Axios.post('/goods/action/check', { params: JSON.stringify(obj.goodsIdList) },
                        {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    ).then(res => {
                        if (res.code == 200) {
                            
                            vm.isLoad = false;
                            let datalist = res.data || {};
                            // notDuplicateGoods不重复的    duplicateList 重复的
                            // if (datalist.notDuplicateGoods && datalist.notDuplicateGoods.length == 0) {//无重复
                            if (datalist.duplicateList && datalist.duplicateList.length > 0) {//无重复
                               
                                vm.addBeforePop(obj, datalist, resolve);
                            } else {//有重复
                              
                                resolve(obj)
                            }
                        } else {
                            vm.$message({
                                message: res.errorMsg || '查询出错！',
                                type: 'error'
                            })
                            vm.isLoad = false;
                        }

                    }).catch(err => {
                        vm.$message({
                            message: err.errorMsg || '查询出错！',
                            type: 'error'
                        })
                        vm.isLoad = false;

                    });
                });
            },
            addBeforePop(obj, datalist, resolve) {
                let vm = this;
                vm.beforeAdd_pop = popup('<add-car-before @cancel="close" @submit="submit" :datalist="datalist"/>', {
                    option: {
                        title: "提示",
                        width: "700px"
                    },
                    popup: {
                        data() {
                            return {
                                datalist
                            };
                        },
                        components: {
                            addCarBefore
                        },
                        methods: {
                            submit(data) {
                                obj.goodsIdList = data.goodsIdList;
                                resolve(obj)
                                vm.beforeAdd_pop.hide();
                            },
                            close(data) {
                                vm.beforeAdd_pop.hide();
                            }
                        }
                    }
                }
                );
                vm.beforeAdd_pop.show();
            },

            //提交
            submitSave() {
                let vm = this;
                let regExp = /^[1-9][0-9]*$/;
                if (new RegExp(regExp).test(vm.amount)) {
                    vm.addOrder();
                } else {
                    this.$message({
                        message: '复本数必须为大于0的正整数！',
                        type: 'info'
                    })
                }
            },
            //取消
            cancelInventtory() {
                let vm = this;
                vm.$emit('cancel')
            },
            //加收订
            addOrder() {
                let vm = this;
                var obj = {
                    goodsIdList: vm.objdata.gids,
                    userId: Cookies.get('UserID'),
                    source: Cookies.get("source"),
                    amount: vm.amount
                }
                vm.isLoad = true;
                vm.beforeAddCar(obj).then(function (obj) {
                    if (obj.goodsIdList && obj.goodsIdList.length > 0) {
                        let fun = addMoreOrder;
                        if (vm.intype && vm.intype == 'bookTemp') {//书目提取进入，需要更换加入购物车接口
                            fun = addMoreOrderBookTemp
                        }
                        fun(obj).then(response => {
                            if(response.code == 200){
                                if (vm.adminState == 0 || vm.adminState == 1) {
                                vm.$message({
                                    message: '加入购物车成功',
                                    type: 'success',
                                    duration: 800
                                });
                            } else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5) {
                                vm.$message({
                                    message: '荐购成功',
                                    type: 'success',
                                    duration: 800
                                });
                            }
                            //添加“加入购物车”埋点
                            let doId = +localStorage.getItem('doId') + 1;
                            localStorage.setItem('doId', doId);
                            insertPoint(obj, 'click', 'shop', doId); //添加埋点
                            vm.$emit('submit');
                            }
                            
                        })
                    } else {
                        vm.$emit('cancel')
                    }
                })
            }
        }
    }
</script>

<style lang='scss'>
    .add_box {
        text-align: center;

        // height: 250px;
        .form_row .form_inp {
            margin-left: -70px;
        }

        .btn_box {
            margin-top: 8px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/AddInventory.vue